import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row space-x-4 mb-8 items-center ml-4" }
const _hoisted_2 = { class: "flex flex-row space-x-4 w-6/12 items-center" }
const _hoisted_3 = { class: "w-2/6" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "w-6/12 grid grid-cols-3 gap-4" }

import { computed } from "vue";
import { Country } from "@/interfaces/Country";
import TextSmall from "@/components/Texts/TextSmall.vue";
import { StatusCountry } from "@/interfaces/StatusCountry";
import GrayCaseForMenu from "@/components/Menus/GrayCaseForMenu.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CountryList',
  props: {
    countryInfos: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "w-full h-auto",
          src: props.countryInfos.flag,
          alt: props.countryInfos.name
        }, null, 8, _hoisted_4)
      ]),
      _createVNode(TextSmall, {
        text: props.countryInfos.name,
        class: "mr-auto"
      }, null, 8, ["text"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(GrayCaseForMenu, {
        status: _unref(StatusCountry).Unvisited,
        "country-code": props.countryInfos.code,
        "with-text": false
      }, null, 8, ["status", "country-code"]),
      _createVNode(GrayCaseForMenu, {
        status: _unref(StatusCountry).Visited,
        "country-code": props.countryInfos.code,
        "with-text": false
      }, null, 8, ["status", "country-code"]),
      _createVNode(GrayCaseForMenu, {
        status: _unref(StatusCountry).ToVisit,
        "country-code": props.countryInfos.code,
        "with-text": false
      }, null, 8, ["status", "country-code"])
    ])
  ]))
}
}

})